import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
// import moment from "moment";

const Tickets = ({ tickets, isMobile }) => {
  const [pageSize, setPageSize] = useState(5);

  // const getAssignmentTime = useCallback(data => {
  //   const { assigned_to, assigned_on, created_on } = data;
  //   if (assigned_to) {
  //     const duration = moment.duration(
  //       moment(assigned_on).diff(moment(created_on))
  //     );
  //     return `${parseInt(duration.asHours(), 10)} h ${parseInt(
  //       duration.asMinutes(),
  //       10
  //     ) % 60} m`;
  //   }
  //   return "N/A";
  // }, []);

  // const getResolutionTime = useCallback(data => {
  //   const { created_on, resolutions } = data;
  //   const { resolved_on } = resolutions?.length ? resolutions[0] : {};
  //   if (resolved_on) {
  //     const duration = moment.duration(
  //       moment(resolved_on).diff(moment(created_on))
  //     );
  //     return `${parseInt(duration.asHours(), 10)} h ${parseInt(
  //       duration.asMinutes(),
  //       10
  //     ) % 60} m`;
  //   }
  //   return "N/A";
  // }, []);

  const columns = useMemo(
    () => [
      {
        Header: "Priority",
        accessor: "request_priority",
        Cell(row) {
          return <div className={`ticket-priority ${row.value}`} />;
        }
      },
      {
        Header: "Ticket Number",
        accessor: "support_ticket_number"
      },
      {
        Header: "Request Nature",
        accessor: "request_nature"
      },
      {
        Header: "Requestor",
        accessor: "requestor_full_name"
      },
      {
        Header: "Assigned To",
        accessor: "assigned_to",
        Cell: ({ value }) => (value ? value.full_name : "Unassigned")
      },
      {
        Header: "Resolved By",
        accessor: "resolutions",
        Cell: ({ value }) => {
          if (value && value.length) {
            return value[0].resolved_by?.full_name;
          }
          return "Not yet Resolved";
        }
      }
    ],
    []
  );

  const handleRowClick = (data) => {
    const ticketId = data?.id || data?._id;
    window.open(`/app/support-tickets/${ticketId}`);
  };

  const tableProps = {
    getTdProps: (state, rowInfo) => ({
      onClick: () => {
        handleRowClick(rowInfo.original);
      }
    })
  };

  return (
    <div className="itms-tickets-container">
      <h1>Tickets</h1>
      <div className="content-wrapper">
        <ReactTable
          {...tableProps}
          className="-highlight tickets itms-tickets"
          data={tickets}
          columns={columns}
          showPageSizeOptions={!isMobile}
          defaultPageSize={tickets.length < 5 ? tickets.length : pageSize}
          onPageSizeChange={setPageSize}
          showPagination={tickets.length > 5}
        />
      </div>
    </div>
  );
};

Tickets.propTypes = {
  tickets: PropTypes.array,
  isMobile: PropTypes.bool
};

Tickets.defaultProps = {
  tickets: [],
  isMobile: false
};

export default Tickets;
